import { useTranslation } from 'react-i18next';
import { GENDER_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const GendersField = (
  props: Omit<SingleSelectorFieldProps<InfluencerFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const genderOptions = useTranslateOptions(GENDER_OPTIONS);

  return (
    <SelectorField<InfluencerFormKeys>
      title={t('Selector.Gender')}
      help={t('Tooltip.Gender')}
      options={genderOptions}
      name={InfluencerSharedKeys.gender}
      {...props}
    />
  );
};
